export default __webpack_public_path__ + "static/media/amex.d74b2412.svg";